<template>
  <div
    class="flex gap-6"
    :class="{ 'mt-10': showSettingsNav }"
  >
    <div
      v-if="showSettingsNav"
      class="px-6 py-2 border-r w-[240px]"
    >
      <p class="text-muted-foreground font-medium text-xs mb-3">
        General
      </p>
      <div class="space-y-1 cursor-pointer">
        <RouterLink
          v-for="link in visibleLinks"
          :key="link.to"
          :to="link.to"
          class="px-2 py-1 rounded text-sm hover:bg-muted transition block"
          :class="{ 'bg-muted': isActive(link.to) }"
        >
          {{ link.label }}
        </RouterLink>
      </div>
    </div>
    <div class="flex-1 min-w-0">
      <RouterView />
    </div>
  </div>
</template>
<script lang="ts">
import { useAuthStore } from '@/stores'

export default {
  data() {
    return {
      links: [
        { label: 'General Settings', to: '/settings/general' },
        { label: 'Integrations', to: '/settings/integrations', superAdminOnly: true },
        { label: 'AML Screening', to: '/settings/aml-screening', superAdminOnly: true },
        { label: 'Departments', to: '/settings/departments' },
        { label: 'Blogs', to: '/settings/blogs' },
        { label: 'Blog Categories', to: '/settings/blog-categories' },
        { label: 'Countries', to: '/settings/countries' },
        { label: 'Modules', to: '/settings/modules' },
        { label: 'Permissions', to: '/settings/permissions' },
        { label: 'Role Visibility', to: '/settings/role-visibility' },
        { label: 'Policy Types', to: '/settings/policy-types' },
        { label: 'Alert Types', to: '/settings/alert-types' },
        { label: 'Question Duplicates', to: '/settings/question-duplicates' },
        { label: 'Form Templates', to: '/settings/form-templates' },
        { label: 'Training Templates', to: '/settings/training-templates' },
        { label: 'Feedbacks', to: '/settings/feedbacks' },
      ]
    }
  },
  computed: {
    visibleLinks() {
      const authStore = useAuthStore()
      return this.links.filter((link) => !link.superAdminOnly || authStore.isSuperAdmin)
    },
    showSettingsNav() {
      return !['form-templates-add', 'form-templates-edit', 'training-templates-settings-details'].includes(String(this.$route.name))
    },
  },
  methods: {
    isActive(to: string) {
      return this.$route.path === to || this.$route.path.startsWith(`${to}/`)
    },
  },
}
</script>
